import { GET, POST } from 'utils/requests.utils'

const BASE_URL = '/cabinet/elopage_promos'

export const fetchItem = (token) => GET(`/app/elopage_promos/${token}`)

export const applyElopagePromo = (token) => POST(`${BASE_URL}/${token}/apply`)
